import { render, staticRenderFns } from "./spot-vr-iframe.vue?vue&type=template&id=db5f805a&scoped=true"
import script from "./spot-vr-iframe.vue?vue&type=script&lang=js"
export * from "./spot-vr-iframe.vue?vue&type=script&lang=js"
import style0 from "./spot-vr-iframe.vue?vue&type=style&index=0&id=db5f805a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5f805a",
  null
  
)

export default component.exports